import { OrgAdminConstants } from '../../../_constants';

const initialState = { getOrgUsersLoading: true, data: '', error: false };

export function getOrgUsers(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_ORG_USERS:
            return {
                getOrgUsersLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_ORG_USERS:
            return {
                getOrgUsersLoading: false,
                data: action.getOrgUsers,
                error: false
            };
        case OrgAdminConstants.ORG_USERS_ERROR:
            return {
                getOrgUsersLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/PaUsers/getOrgUsers.reducer.js